// extracted by mini-css-extract-plugin
module.exports = {"root":"EventMassEmailMaintenanceTable_root__2bmMM","dialog":"EventMassEmailMaintenanceTable_dialog__2RD0l","submitButton":"EventMassEmailMaintenanceTable_submitButton__3plhN"};